module.exports = __webpack_public_path__ + "static/media/Lightning-Bug-App-Logo-Horizontal.d66ec178.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Lightning-Bug-App-Logo-Horizontal.png
// module id = 1776
// module chunks = 1